/* RESPONSIBLE TEAM: team-automation-foundations */
import AutomationFinAIAgentProcedureSimulationsTestEditRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/procedures/procedure/preview/simulations/test/edit';

export default AutomationFinAIAgentProcedureSimulationsTestEditRoute;
